import { render, staticRenderFns } from "./home.vue?vue&type=template&id=5aaedaa3&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=5aaedaa3&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aaedaa3')) {
      api.createRecord('5aaedaa3', component.options)
    } else {
      api.reload('5aaedaa3', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=5aaedaa3&", function () {
      api.rerender('5aaedaa3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/user/modal/tabs/home.vue"
export default component.exports